import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker, Select } from 'antd';
import { Buildings, CalendarBlank, User } from '@phosphor-icons/react';
import Button from '../../../components/Button';
import Typography from '../../../components/Typography';
import COLORS from '../../../util/constants/colors';
import { mairaRangeDisabledDate } from '../MairaFilters';
import { DATE_FORMAT } from './helpers';

const FilterLabel = ({ icon: Icon, children }) => (
  <Typography variant="text" size="small" bold>
    <Icon size={16} color={COLORS.BLUE_PRIMARY_LITE} weight="bold" />
    &nbsp;
    {children}
  </Typography>
);

FilterLabel.propTypes = {
  icon: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
};

const toOptions = (items) => (items || []).map((item) => ({ value: item.id, label: item.name }));

const UserActivityFilters = ({
  filters,
  onChange,
  filterOptions,
  loading,
  onApply,
  onClear,
}) => {
  const [calendarDates, setCalendarDates] = useState([]);
  const { dateRange } = filters;

  return (
    <div className="maira-filters">
      <div className="maira-filter-item maira-filter-date">
        <FilterLabel icon={CalendarBlank}>Date Range</FilterLabel>
        <DatePicker.RangePicker
          allowClear={false}
          value={[
            dateRange.startDate ? moment(dateRange.startDate, DATE_FORMAT) : null,
            dateRange.endDate ? moment(dateRange.endDate, DATE_FORMAT) : null,
          ]}
          format={DATE_FORMAT}
          disabledDate={(current) => mairaRangeDisabledDate(current, calendarDates)}
          onCalendarChange={(nextCalendarDates) => setCalendarDates(nextCalendarDates || [])}
          onChange={(_, dateStrings) => {
            onChange({ dateRange: { startDate: dateStrings[0] || null, endDate: dateStrings[1] || null } });
            setCalendarDates([]);
          }}
          onOpenChange={(open) => {
            if (!open) setCalendarDates([]);
          }}
        />
      </div>
      <div className="maira-filter-item">
        <FilterLabel icon={Buildings}>Departments</FilterLabel>
        <Select
          mode="multiple"
          allowClear
          optionFilterProp="label"
          placeholder="All departments"
          value={filters.departmentIds}
          options={toOptions(filterOptions?.departments)}
          onChange={(departmentIds) => onChange({ departmentIds })}
        />
      </div>
      <div className="maira-filter-item">
        <FilterLabel icon={User}>Team Members</FilterLabel>
        <Select
          mode="multiple"
          allowClear
          optionFilterProp="label"
          placeholder="All team members"
          value={filters.userIds}
          options={toOptions(filterOptions?.users)}
          onChange={(userIds) => onChange({ userIds })}
        />
      </div>
      <div className="maira-filter-actions">
        <Button type="secondary" size="xsmall" label="Clear" onClick={onClear} disabled={loading} />
        <Button type="primary" size="xsmall" label="Update" onClick={onApply} disabled={loading} />
      </div>
    </div>
  );
};

UserActivityFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  filterOptions: PropTypes.object,
  loading: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

UserActivityFilters.defaultProps = {
  filterOptions: {},
  loading: false,
};

export default UserActivityFilters;
